export const gameRoute = {
    path: "/game",
    name: "游戏数据",
    meta: { title: "游戏数据", affix: true },
    component: resolve => require(["@/components/index"], resolve),
    children: [
        {
            path: "tycoon/facility_level",
            name: "用户设施等级",
            component: resolve =>
                require(["@/components/game/tycoon/FacilityLevel"], resolve),
            meta: { title: "用户设施等级" }
        },
        {
            path: "tycoon/retention_facility",
            name: "新用户留存设施等级",
            component: resolve =>
                require(["@/components/game/tycoon/RetentionFacility"], resolve),
            meta: { title: "新用户留存设施等级" }
        },
        {
            path: "tycoon/cost",
            name: "钻石消耗",
            component: resolve =>
                require(["@/components/game/tycoon/Cost"], resolve),
            meta: { title: "钻石消耗" }
        },
        {
            path: "song/level_error",
            name: "关卡错误",
            component: resolve =>
                require(["@/components/game/song/SongLevelError"], resolve),
            meta: { title: "关卡错误" }
        },
        {
            path: "school/build_level",
            name: "建筑等级",
            component: resolve =>
                require(["@/components/game/school/BuildLevel"], resolve),
            meta: { title: "建筑等级" }
        },
        {
            path: "school/user_star",
            name: "用户星级",
            component: resolve =>
                require(["@/components/game/school/UserStar"], resolve),
            meta: { title: "用户星级" }
        },
        {
            path: "cartycoon/facility",
            name: "用户设施等级",
            component: resolve =>
                require(["@/components/game/cartycoon"], resolve),
            meta: { title: "用户设施等级" }
        },
        {
            path: "cartycoon/build_user_num",
            name: "建造人数统计",
            component: resolve =>
                require(["@/components/game/cartycoon/BuildUser"], resolve),
            meta: { title: "建造人数统计" }
        },
        {
            path: "crazycity/facility",
            name: "用户设施等级",
            component: resolve =>
                require(["@/components/game/crazycity"], resolve),
            meta: { title: "用户设施等级" }
        },
        {
            path: "trend_summary",
            name: "整体趋势",
            component: resolve => require(["@/components/game/trendSummary"], resolve),
            meta: { title: "整体趋势" }
        },
        {
            path: "click",
            name: "游戏点击数据",
            component: resolve =>
                require(["@/components/game/restaurant/AppClick"], resolve),
            meta: { title: "游戏点击数据" }
        },
    ]
}


// WEBPACK FOOTER //
// ./src/router/game.js